import { serviceMaker, methods, api } from "@/http/index.js";

export const getTeamMappingList = () =>
  serviceMaker(`/ticketmapping/team`, methods.GET, api.NGB);
export const getcategoryTemplate = (id) =>
  serviceMaker(`/subcategory/byCategory?category=${id}`, methods.GET, api.NGB);
export const getCreateTemplate = () =>
  serviceMaker(`/ticketmapping/team/template`, methods.GET, api.NGB);
export const createTeamMappingList = (data) =>
  serviceMaker(`/ticketmapping/team`, methods.POST, api.NGB, data);
export const editTeamMappingTemplate = (id) =>
  serviceMaker(`/ticketmapping/team/${id}`, methods.GET, api.NGB);
export const updateTeamMapping = (id, data) =>
  serviceMaker(`/ticketmapping/team/${id}`, methods.PUT, api.NGB, data);
export const deleteTeamMappingList = (id) =>
  serviceMaker(`/ticketmapping/team/${id}`, methods.DELETE, api.NGB);
